import { Slot } from "expo-router";
import { View } from "react-native";

import { AppSidebar } from "@/components/navigation/AppSidebar";

export default function WebTabsLayout() {
    return (
        <View className="min-h-screen flex-1 flex-row bg-background">
            <AppSidebar />
            <View className="flex-1 items-center bg-background">
                <View className="h-full w-full max-w-lg flex-1 border-x border-border">
                    <Slot />
                </View>
            </View>
        </View>
    );
}
